export class MessageTypeEnum {
    static Text = 0;
    static Loading = 99;
    static System = 999;
}